<h2 mat-dialog-title>Create Ledger</h2>

<mat-dialog-content class="tw-pt-4 tw-pb-0">
  <form [formGroup]="form" class="tw-space-y-4">
    <mat-form-field appearance="outline" class="tw-w-full">
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" required />
      <mat-error *ngIf="form.get('name')?.hasError('required')">Name is required</mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" class="tw-w-full">
      <mat-label>Description (Optional)</mat-label>
      <input matInput formControlName="description" />
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button (click)="close()">Cancel</button>
  <button mat-raised-button color="primary" [disabled]="!form.valid" (click)="save()">
    Create
  </button>
</mat-dialog-actions>
